import { usePostHttp } from "../../http.hook";
import type { IBrand } from "../../../../types/models/brands.models.types";

interface IBody {
  name: string;
}

interface IResponse extends IBrand {}

export function useCreateBrandHttp() {
  return usePostHttp<IBody, IResponse>({
    path: "/brand/brands",
  });
}
